import React, { Component } from 'react';
import './Form.css';

class Form extends Component{
    constructor(props){
        super(props);
        this.state = {
            todo : '',
            isCheckedOut : false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(evt){
        this.setState({
            [evt.target.name] : evt.target.value
        })
    }
    handleSubmit(evt){
        if(evt.key === 'Enter'){
            evt.preventDefault();
            this.props.handleTask(this.state);
            this.setState({todo : ''})
        }
    }
    render(){
        return(
            <div className='Form'>
                <input type= "text" onChange={this.handleChange}
                name = "todo"
                placeholder = "Create a new todo..." value = {this.state.todo}
                onKeyDown = {this.handleSubmit}
                style = {{backgroundColor : this.props.darkTheme ? 'hsl(235, 24%, 19%)': '#fff',
                color : this.props.darkTheme ? 'white' : 'hsl(237, 14%, 26%)'}}
                />
            </div>
        )
    }
}

export default Form;